import { Link } from 'react-router-dom';

export function Pricing() {
  return (
    <section id="pricing" className="py-24 lg:py-32 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A] mb-6">
            Straightforward pricing
          </h2>
          <p className="text-lg text-[#505A5A]/70 leading-relaxed max-w-3xl mx-auto">
            Our management fees typically range from <strong className="text-[#505A5A]">15% to 25%</strong> depending on the rental type and level of support you need.
          </p>
        </div>

        <div className="space-y-8 mb-12">
          <div className="text-center">
            <p className="text-xl text-[#505A5A] font-medium mb-3">
              Management fees: 15-25% of rental income
            </p>
            <p className="text-base text-[#505A5A]/70 max-w-2xl mx-auto">
              Percentage varies based on rental type (short-term vs medium-term) and whether you need full management or co-hosting support.
            </p>
          </div>

          <div className="text-center">
            <p className="text-xl text-[#505A5A] font-medium mb-3">
              Compliance reviews and setup: Custom quotes
            </p>
            <p className="text-base text-[#505A5A]/70 max-w-2xl mx-auto">
              Quoted based on complexity so you only pay for what you need. Simple reviews start lower, complex multi-unit assessments are priced accordingly.
            </p>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-4 mb-12">
          <div className="bg-[#F0F0F0] px-6 py-3 rounded-full">
            <span className="text-base font-medium text-[#505A5A]">No long-term contracts</span>
          </div>
          <div className="bg-[#F0F0F0] px-6 py-3 rounded-full">
            <span className="text-base font-medium text-[#505A5A]">No hidden fees</span>
          </div>
          <div className="bg-[#F0F0F0] px-6 py-3 rounded-full">
            <span className="text-base font-medium text-[#505A5A]">No pushing Airbnb where it doesn't make sense</span>
          </div>
        </div>

        <div className="text-center">
          <Link 
            to="/revenue-calculator"
            className="inline-block border-2 border-[#882629] text-[#882629] px-8 py-4 rounded-full text-base font-medium hover:bg-[#882629] hover:text-white transition-all cursor-pointer whitespace-nowrap"
          >
            Get pricing for my property
          </Link>
        </div>
      </div>
    </section>
  );
}
